export default __webpack_public_path__ + "static/media/Arçelik_Yetkili Servis_Çalışanı_Yetkilisi_Aydınlatma_Metni.1f1de1c8.pdf";